import {Component, ElementRef, Input, ViewChild} from '@angular/core';

@Component({
    selector: 'app-collapsible-box',
    templateUrl: './collapsible-box.component.html',
    styleUrl: './collapsible-box.component.scss'
})
export class CollapsibleBoxComponent {
    @Input() title = '';
    @ViewChild('expansionButton', {static: true}) expansionButton!: ElementRef<HTMLButtonElement>;
    @ViewChild('expansionPanel', {static: true}) expansionPanel!: ElementRef<HTMLElement>;

    public openCollapsible(ev: HTMLButtonElement = this.expansionButton.nativeElement, target: HTMLElement = this.expansionPanel.nativeElement) {
        ev.classList.toggle('active');
        if (target.classList.contains('collapsed')) {
            target.classList.remove('collapsed');
        } else {
            target.classList.add('collapsed');
        }
    }

    public close(ev: HTMLButtonElement = this.expansionButton.nativeElement, target: HTMLElement = this.expansionPanel.nativeElement) {
        if (ev.classList.contains('active')) {
            ev.classList.remove('active');
        }
        if (!target.classList.contains('collapsed')) {
            target.classList.add('collapsed');
        }
    }

    public open(ev: HTMLButtonElement = this.expansionButton.nativeElement, target: HTMLElement = this.expansionPanel.nativeElement) {
        if (!ev.classList.contains('active')) {
            ev.classList.add('active');
        }
        if (target.classList.contains('collapsed')) {
            target.classList.remove('collapsed');
        }
    }

    public show(options: ScrollIntoViewOptions = {behavior: 'instant', block: 'start'}) {
        this.expansionButton.nativeElement.scrollIntoView(options);
    }
}
